import { render } from "./detail.vue?vue&type=template&id=b1497698&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=b1497698&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1497698"]])

export default __exports__